import { useLang } from "@/i18n";

const FLEET = [
  { id: "eco", model: "Tesla Model Y", image: "/fleet-eco.jpg", alt: "Tesla Model Y noire", tagCls: "text-[#34d399] border-[#34d399]/40", overCls: "text-[#34d399]" },
  { id: "business", model: "Mercedes Classe E", image: "/fleet-business.jpg", alt: "Mercedes-Benz Classe E noire", tagCls: "text-[#c9a24d] border-[#c9a24d]/40", overCls: "text-[#c9a24d]" },
  { id: "van", model: "Mercedes Classe V", image: "/fleet-van.jpg", alt: "Van Mercedes-Benz Classe V noir", tagCls: "text-[#c9a24d] border-[#c9a24d]/40", overCls: "text-[#c9a24d]" },
  { id: "prestige", model: "Mercedes Classe S", image: "/fleet-prestige.jpg", alt: "Mercedes-Benz Classe S noire", tagCls: "text-[#c9a24d] border-[#c9a24d]/50 font-bold", overCls: "text-[#c9a24d]" },
];

export default function Fleet({ onChoose }) {
  const { t } = useLang();
  return (
    <section id="flotte" className="py-24 px-6 border-b border-[#212631] bg-[#040507]" data-testid="fleet-section">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#c9a24d] block mb-2">{t("fleet.kicker")}</span>
            <h2 className="font-disp text-3xl md:text-5xl text-white">{t("fleet.title")}</h2>
          </div>
          <p className="text-sm text-[#9ea8b6] max-w-sm">{t("fleet.sub")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {FLEET.map((v) => (
            <div key={v.id} data-testid={`fleet-card-${v.id}`}
              className={`bg-[#0d1017] border ${v.id === "prestige" ? "border-[#c9a24d]/40 hover:border-[#c9a24d] shadow-2xl" : "border-[#212631] hover:border-[#c9a24d]/60 shadow-xl"} rounded-2xl p-5 flex flex-col justify-between group transition-all duration-300`}>
              <div>
                <div className="h-44 rounded-xl mb-5 overflow-hidden relative border border-[#212631]">
                  <img src={v.image} alt={v.alt} loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#060709]/70 via-transparent to-transparent"></div>
                  <div className={`absolute top-3 left-3 font-mono text-[10px] bg-[#060709]/90 px-2.5 py-1 rounded-md border ${v.tagCls}`}>{t(`v.${v.id}.tag`)}</div>
                  <div className="absolute bottom-2 right-2 font-mono text-[10px] bg-[#060709]/80 text-[#8c98a9] px-2 py-0.5 rounded">{t(`v.${v.id}.cap`)}</div>
                </div>
                <span className={`font-mono text-[11px] uppercase tracking-wider block mb-1 ${v.overCls}`}>{t(`v.${v.id}.over`)}</span>
                <h3 className="font-disp text-xl text-white mb-2">{v.model}</h3>
                <p className="text-xs text-[#8c98a9] mb-4 leading-relaxed">{t(`v.${v.id}.desc`)}</p>
              </div>
              <div className="pt-3 border-t border-[#212631] flex items-center justify-between">
                <span className="font-mono text-[11px] text-[#8c98a9]">{t(`v.${v.id}.foot`)}</span>
                <button onClick={() => onChoose(v.id)} data-testid={`fleet-choose-${v.id}`}
                  className="font-geom text-xs font-bold text-[#c9a24d] group-hover:translate-x-1 rtl:group-hover:-translate-x-1 transition-transform inline-flex items-center gap-1">
                  {t("fleet.choose")}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
